/*
 * @Author: Zhouqi
 * @Date: 2026-03-26 15:00:45
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-26 19:45:58
 */
import { useEffect, useRef } from 'react';

import UserStore from '@/store/User';

import { MOCK_ENABLE, STORAGE_KEYS } from '../config';
import { CouponManager } from '../coupon/CouponManager';
import { FirstOrderCampaignStrategy } from '../strategies/firstOrderCampaign';
import { MarketingStrategy } from '../types';

export function useMarketingStrategy() {
  const currentVip = UserStore((state) => state.currentVip);
  const isInviteCodeBinding = UserStore((state) => state.isInviteCodeBinding);
  const isExecutedRef = useRef(false);
  const setNewUserCountDownTime = UserStore((store) => store.setNewUserCountDownTime);
  const newUserCountDownTime = UserStore((store) => store.newUserCountDownTime);

  // 每秒递减倒计时
  useEffect(() => {
    if (newUserCountDownTime <= 0) return;

    const timer = setInterval(() => {
      setNewUserCountDownTime((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [newUserCountDownTime, setNewUserCountDownTime]);

  useEffect(() => {
    if (!currentVip.isRequestEnd || isExecutedRef.current || isInviteCodeBinding) return;

    // 开发模式下每次都重置弹窗标记，方便调试
    if (MOCK_ENABLE) {
      localStorage.removeItem(STORAGE_KEYS.FIRST_ORDER_MODAL_SHOWN);
      CouponManager.getInstance().reset();
    }

    const execute = async () => {
      try {
        isExecutedRef.current = true;

        const couponManager = CouponManager.getInstance();
        await couponManager.fetchAllCoupons();
        const topCoupon = couponManager.getTopPriorityCoupon();

        const strategies: MarketingStrategy[] = [
          new FirstOrderCampaignStrategy(topCoupon),
        ];

        let activated = false;
        for (const strategy of strategies) {
          const can = await strategy.canActivate();
          if (can) {
            strategy.show();
            activated = true;
            break;
          }
        }

        if (!activated) {
          UserStore.getState().setShowNewUserCountDownBaner(false);
        }
      } catch (error) {
        console.error('营销策略执行失败:', error);
      }
    };

    execute();
  }, [currentVip.isRequestEnd, isInviteCodeBinding]);
}
